
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/classes",
      function () {
        return require("private-next-pages/book/classes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/classes"])
      });
    }
  